export const STATIC_DASHBOARD_PATH = "/";
export const DASHBOARD_PATH = "/dashboard";
